import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { FilterData, FieldWrapper } from '@blocs.filter';
import FormikSimpleCheckbox from '@minecraft.formik-simple-checkbox';

const StyledFormikSimpleCheckbox = styled(FormikSimpleCheckbox)`
  font-size: 0.875rem;
  font-weight: 500;
  margin: 0;
`;

type Props = FilterData;

const SingleCheckbox: FC<Props> = ({ name, label }) => {
  return (
    <FieldWrapper>
      <StyledFormikSimpleCheckbox checkmarkSize="small" name={name} label={label} />
    </FieldWrapper>
  );
};

export default memo(SingleCheckbox);
